import Component from './instagram_prize_table.vue'
export default Component
